<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="competencyValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.name') + ' (en)'"
                label-classes="form-control-label required"
                :placeholder="$t('common.name') + ' (en)'"
                v-model="value.name_en"
                name="name_en"
                rules="required"
                :error="errors.get('name_en')">
            </base-input>

            <base-input class="mb-3"
                :label="$t('common.name') + ' (fr)'"
                label-classes="form-control-label required"
                :placeholder="$t('common.name') + ' (fr)'"
                v-model="value.name_fr"
                name="name_fr"
                rules="required"
                :error="errors.get('name_fr')">
            </base-input>

            <base-select class="mb-4"
                :label="$t('common.competency-domain')"
                :placeholder="$t('common.competency-domain')"
                v-model="value.domain_id"
                :options="domains"
                clearable
            >
            </base-select>

            <base-input class="mb-3"
                :label="$t('common.order')"
                :placeholder="$t('common.order')"
                v-model="value.position"
                name="position"
                :error="errors.get('position')">
            </base-input>

            <base-switch class="mb-3"
                v-model="value.active"
                :label="$t('common.active')"
            ></base-switch>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            errors: {
                type: Object,
                required: true
            },
            modal: {
                type: Object,
                default: null
            },
            domains: {
                type: Object,
                required: true
            },
        },

        created() {
            this.errors.setValidator('competencyValidator', this)
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
